/**
 * Contains functions that are used to support fullscreen operations
 */

import { logError } from 'derivita/omaha/base/logging';
import sizeState from '../../ui/state/size_state';

export async function toggleFullscreen(body: HTMLElement): Promise<boolean> {
  if (document.fullscreenElement) {
    return exitFullscreen();
  } else {
    return enterFullscreen(body);
  }
}

export async function exitFullscreen() {
  document.body.focus();
  try {
    // The document must have focus before exiting full screen will work
    await document.exitFullscreen();
  } catch (e) {
    // most likely already exited
    console.error('Failed to exit fullscreen', e);
    return false;
  }

  updateSize(true);
  return false;
}

export async function enterFullscreen(body: HTMLElement) {
  try {
    await body.requestFullscreen({ navigationUI: 'hide' });
  } catch (e) {
    logError(`Failed to enter fullscreen for Focus Mode: ${e}`);
    return false;
  }

  updateSize();
  return true;
}

function updateSize(reset = false) {
  if (reset) {
    sizeState.reset();
  } else {
    sizeState.setSize({
      width: window.innerWidth,
      height: window.innerHeight - 150, // Keeps the check answer button on the page
    });
  }
}

export function supportsFullscreen(body: HTMLElement): boolean {
  return !!body.requestFullscreen;
}

export function isFullScreen(doc: Document): boolean {
  return !!doc.fullscreenElement;
}

export function canGoFullscreen(doc: Document): boolean {
  return doc.fullscreenEnabled && !!doc.documentElement.requestFullscreen;
}
